import { createSelector } from 'reselect';

import { StateType } from '../../../../states';
import { GRAssetsBySkinId } from '../../constants/assets';
import { selectGRGlobalSkinId } from '../../selectors/global/globalPrimary.selector';
import {
  selectGRMiscCurrentNotification,
  selectGRMiscTmpNotifications,
} from '../../selectors/misc/miscPrimary.selector';
import { GRNotificationTypes } from '../../types/notification';

export const selectShowGRRoundFailedNotification = createSelector(
  [selectGRMiscCurrentNotification, selectGRMiscTmpNotifications],
  (currentNotif, notifications) => {
    return currentNotif && currentNotif.type === GRNotificationTypes.ROUND_FAILED && notifications.length === 1;
  },
);

const selectPrimaryButtonBySkinId = (state: StateType) => {
  const skinId = selectGRGlobalSkinId(state);

  if (!skinId) {
    return GRAssetsBySkinId.GIFT_RACE.Buttons.primary;
  }

  return GRAssetsBySkinId[skinId].Buttons.primary;
};

const selectGRRoundFailedNotificationProps = createSelector(
  [selectShowGRRoundFailedNotification, selectPrimaryButtonBySkinId],
  (show, primaryButtonPath) => ({
    show,
    primaryButtonPath,
  }),
);

export default selectGRRoundFailedNotificationProps;
